export const validateEmail = (email) => {
  const re = /^[a-zA-Z]+[a-zA-Z0-9.\-_]+@[a-zA-Z0-9]+\.[A-Za-z]+$/;
  return email && re.test(String(email).toLowerCase());
}
export const validateUserEmail = (user) => {
  const re = /^[a-zA-Z]+[a-zA-Z0-9.\-_]+$/;
  return email && re.test(String(user).toLowerCase());
}
export const validateName = (nombre) => {
  const re = /^[A-Za-zñÑáéíóúÁÉÍÓÚ]+$/;
  return re.test(nombre);
}
export function validateNumber(text) {
  var re = new RegExp('^[0-9]+$');
  return text && re.test(text);
}
export function validateText(text, ini = 2, end = 64) {
  var re = new RegExp('^[a-zA-ZáéíóóÁÉÍÓÚ]{' + ini + ',' + end + '}$');
  return text && re.test(text);
}
export function validateTextNumber(text, ini = 2, end = 64) {
  var re = new RegExp('^[a-zA-Z0-9]{' + ini + ',' + end + '}$');
  return text && re.test(text);
}
export function validateTextAndSpace(text, ini = 2, end = 64) {
  var re = new RegExp('^[a-zA-ZáéíóúÁÉÍÓÚ ]{' + ini + ',' + end + '}$');
  return text && re.test(text);
}
export function validateTextNumberAndSpace(text, ini = 2, end = 64) {
  var re = new RegExp('^[a-zA-Z0-9áéíóúÁÉÍÓÚ ]{' + ini + ',' + end + '}$');
  return text && re.test(text);
}
export function validatePhone(text) {
  return /^[+]{1}[0-9]{3,16}$/.test(text);
}
export function validatePassword(text) {
  return /(?=.*[a-z])/.test(text) && /(?=.*[A-Z])/.test(text) && /(?=.*[0-9])/.test(text) && /(?=.{8,})/.test(text);
}
